namespace Nobox.CRM {
    export interface ProductdealsForm {
        DealId: Serenity.StringEditor;
        PdtId: Serenity.ServiceLookupEditor;
        PdtIdNm: Serenity.StringEditor;
        Currencies: CurrencyEditor;
        PdtPrc: Serenity.DecimalEditor;
        PdtQty: Serenity.IntegerEditor;
        PdtDisc: Serenity.IntegerEditor;
        PdtTotal: AutoNumericEditor;
        PdtImg: Serenity.ImageUploadEditor;
        PdtDesc: Serenity.TextAreaEditor;
        PdtCd: Serenity.StringEditor;
        UnitIds: ProductUnitEditor;
    }

    export class ProductdealsForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Productdeals';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductdealsForm.init)  {
                ProductdealsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ServiceLookupEditor;
                var w2 = CurrencyEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.IntegerEditor;
                var w5 = AutoNumericEditor;
                var w6 = s.ImageUploadEditor;
                var w7 = s.TextAreaEditor;
                var w8 = ProductUnitEditor;

                Q.initFormType(ProductdealsForm, [
                    'DealId', w0,
                    'PdtId', w1,
                    'PdtIdNm', w0,
                    'Currencies', w2,
                    'PdtPrc', w3,
                    'PdtQty', w4,
                    'PdtDisc', w4,
                    'PdtTotal', w5,
                    'PdtImg', w6,
                    'PdtDesc', w7,
                    'PdtCd', w0,
                    'UnitIds', w8
                ]);
            }
        }
    }
}
